import { render, staticRenderFns } from "./main-section-itemsbelongings-list.vue?vue&type=template&id=c59e5a0e&scoped=true"
import script from "./main-section-itemsbelongings-list.vue?vue&type=script&lang=js"
export * from "./main-section-itemsbelongings-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e5a0e",
  null
  
)

export default component.exports